// extracted by mini-css-extract-plugin
export default {"smallField":"LateFeeSection_smallField__L1QLG","typeField":"LateFeeSection_typeField__JkxWB","intervalField":"LateFeeSection_intervalField__MWMJp"};